/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_DofollowInputs */

const en_landing_pricing_feature_dofollow = /** @type {(inputs: Landing_Pricing_Feature_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow links`)
};

const zh_landing_pricing_feature_dofollow = /** @type {(inputs: Landing_Pricing_Feature_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow 外链`)
};

/**
* | output |
* | --- |
* | "Dofollow links" |
*
* @param {Landing_Pricing_Feature_DofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_dofollow = /** @type {((inputs?: Landing_Pricing_Feature_DofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_DofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_dofollow(inputs)
	return zh_landing_pricing_feature_dofollow(inputs)
});
export { landing_pricing_feature_dofollow as "landing.pricing.feature_dofollow" }